import { render, staticRenderFns } from "./AdyenPlatformSection.vue?vue&type=template&id=5bf85981"
import script from "./AdyenPlatformSection.vue?vue&type=script&lang=ts"
export * from "./AdyenPlatformSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports